export class Money {
  constructor(public readonly amount: string,
              public readonly currencyCode: string) { }

  public toString() {
    // obviously not a scalable solution
    if (this.currencyCode === 'AUD')
      return 'AU$' + this.amount;
    else if (this.currencyCode === 'USD')
      return '$' + this.amount;
    else if (this.currencyCode === 'MXN')
      return `${this.amount} MXN`;
    throw new Error('not implemented');
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/models/money.ts